import { render, staticRenderFns } from "./WeeklyProgressLegend.vue?vue&type=template&id=0c4916b0&scoped=true"
import script from "./WeeklyProgressLegend.vue?vue&type=script&lang=js"
export * from "./WeeklyProgressLegend.vue?vue&type=script&lang=js"
import style0 from "./WeeklyProgressLegend.vue?vue&type=style&index=0&id=0c4916b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4916b0",
  null
  
)

export default component.exports